/* eslint-disable */
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import "./index.css"
import '@yapstudios/yap-content-builder/dist/index.css'
ReactDOM.render(<App />, document.getElementById('root'))
